/** Organization experimental feature: real factories (tasks, lines, factory apps). */
export const FEATURE_FACTORIES = "factories";

/** Organization experimental feature: Claude managed agents on the canvas. */
export const FEATURE_CLAUDE_MANAGED_AGENTS = "claude_managed_agents";

/** Organization experimental feature: SetupProvider wizard for GitHub and similar integrations. */
export const FEATURE_NEW_INTEGRATION_SETUP_FLOW = "new_integration_setup_flow";

/** Organization experimental feature: Sentry intake setup from the Backlog column. */
export const FEATURE_FACTORY_SENTRY_INTAKE = "factory_sentry_intake";

/** Organization experimental feature: manual "Add intake" entry for Jira in the Backlog column menu. */
export const FEATURE_FACTORY_JIRA_INTAKE = "factory_jira_intake";

/** Organization experimental feature: manual "Add intake" entry for Productive.io in the Backlog column menu. */
export const FEATURE_FACTORY_PRODUCTIVE_INTAKE = "factory_productive_intake";

/** Organization experimental feature: in-progress workspace Models settings page. */
export const FEATURE_WORKSPACE_MODELS = "workspace_models";

/** Organization experimental feature: workspace Agent resources (MCP connections). */
export const FEATURE_WORKSPACE_AGENT_RESOURCES = "workspace_agent_resources";

/** Organization experimental feature: organization LLM Models (BYOK) settings page. */
export const FEATURE_ORGANIZATION_BYOK = "organization_byok";

/** Organization experimental feature: blank custom automations on Verify, Done, and phase columns. */
export const FEATURE_FACTORY_CUSTOM_AUTOMATIONS = "factory_custom_automations";

/** Organization experimental feature: Mergeable chip on task cards and Merge button on pull request review. */
export const FEATURE_FACTORY_PULL_REQUEST_MERGE = "factory_pull_request_merge";
